/**
 * Formaterar ett datum till svenskt format (YYYY-MM-DD)
 * @param {string|Date} dateString - Datum att formatera
 * @returns {string} Formaterat datum eller tom sträng om inget datum finns
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('sv-SE');
};

/**
 * Formaterar ett belopp till svensk valuta (SEK)
 * @param {number} amount - Belopp att formatera
 * @returns {string} Formaterat belopp med valuta
 */
export const formatAmount = (amount) => {
  if (!amount) return '0 kr';
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

